module.exports = __webpack_public_path__ + "img/16581290_L.a39226fd.png";